import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  HOUSEKEEPING_STATUS_ASSIGN_REQUEST,
  HOUSEKEEPING_STATUS_NEW_REQUEST,
  HOUSEKEEPING_STATUS_ON_HOLD,
  HOUSEKEEPING_STATUS_RESOLVED,
} from '../../../../constants/DashboardConst';
import { updateHousekeepingOrderStatus } from '../../../../utils/dashboardAPIUtils';
import {
  formatDateWithInitialFormat,
  generatedElapsedTime,
} from '../../../../utils/dashboardUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  fetchHousekeepingOrdersList,
  housekeepingOrdersSelector,
  setDashboardNewOrder,
} from '../../DashboardSlice';
import './DashboardHousekeepingView.scss';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const DashboardHousekeepingView = (props) => {
  const { obj, onViewToggle, hotelId, showLoader = () => {} } = props;
  const allOrdersList = useSelector(housekeepingOrdersSelector);

  const [order, setOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const currOrder = allOrdersList.find((o) => o.id === obj?.id);
    if (currOrder) {
      setOrder(currOrder);
      let generatedItems = currOrder?.items.map((e, i) => {
        return { ...e, isExpand: true, panelId: `panel${i}` };
      });
      setOrderItems(generatedItems);
    }
  }, [obj, allOrdersList]);

  const onClickBack = () => {
    dispatch(setDashboardNewOrder(null));
    onViewToggle('', false, null);
  };

  const onUpdatingStatus = async (newStatus, successMessage, errorMessage) => {
    const lang = decryptLocalStorage('lang');
    const language = lang !== 'en' ? lang : '';
    try {
      dispatch(stepUpLoaderCount());
      if (order?.id) {
        await updateHousekeepingOrderStatus(hotelId, order.id, newStatus, language);
        await dispatch(fetchHousekeepingOrdersList(hotelId));
        notificationManager('success', successMessage);
      }
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors ? error?.graphQLErrors?.[0]?.message : errorMessage,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    return true;
  };
  const getTimeDifference = (time, startTime) => {
    const startDate = startTime ? moment.unix(startTime) : moment();
    const endDate = moment.unix(time);
    const timeDifference = generatedElapsedTime(startDate, endDate);
    return timeDifference;
  };

  const viewDate = (date) => {
    return moment.unix(date).format('DD MMM, hh:mm A');
  };

  const handleChange = (panel) => (event, newExpanded) => {
    let generatedNewItems = orderItems?.map((item) => {
      return {
        ...item,
        isExpand: item.panelId === panel ? !item.isExpand : item.isExpand,
      };
    });

    setOrderItems(generatedNewItems);
  };
  return (
    <div className='hk-dashboard-view container mt-4 mb-3 detail-view-65 pb-4'>
      <div className='mt-5 row mx-0'>
        <div className='col-md-6 px-0 d-flex align-items-center'>
          <Button
            variant='text'
            color='secondary'
            size='small'
            startIcon={<ArrowBack />}
            onClick={(e) => onClickBack()}
            className='me-2'
          >
            Back
          </Button>
          <span className='page-title'>
            Room {order?.roomNo} - {order?.serviceName}
          </span>
        </div>
      </div>
      <div className='card shadow mt-4 mb-4 pb-5 h-100 px-4 pt-4'>
        <div className='row mb-4'>
          <div className='col-md-4'>
            <div className='details-label'>Ticket no</div>
            <div className='details-value'>{order?.id?.split('-')[0]}</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Room Number</div>
            <div className='details-value'>{order?.roomNo}</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Status</div>
            <div className={`status ${order?.statusClass}`}>{order?.orderStatus}</div>
          </div>
        </div>
        <div className='row mb-4'>
          <div className='col-md-4'>
            <div className='details-label'>Request type</div>
            <div className='details-value'>{order?.requestType}</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Service name</div>
            <div className='details-value'>{order?.serviceName}</div>
          </div>
          {order?.status !== HOUSEKEEPING_STATUS_RESOLVED && (
            <div className='col-md-4'>
              <div className='details-label'>Time Elapsed</div>
              <div className='details-value'>{getTimeDifference(order?.createdAt)}</div>
            </div>
          )}
        </div>
        <div className='row mb-4'>
          <div className='col-md-4'>
            <div className='details-label'>Guest name</div>
            <div className='details-value'>{order?.guestName}</div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Date & Time</div>
            <div className='details-value'>{viewDate(order?.createdAt)}</div>
          </div>
          {order?.status === HOUSEKEEPING_STATUS_RESOLVED && order?.resolvedTime && (
            <div className='col-md-4'>
              <div className='details-label'>Request Resolved</div>
              <div className='details-value'>
                {formatDateWithInitialFormat(
                  order?.resolvedTime,
                  'DD/MM/YYYY HH:mm',
                  'DD MMM, hh:mm a',
                )}
              </div>
            </div>
          )}
        </div>
        <div className='row mb-4'>
          <div className='col-md-12'>
            <div className='details-label'>Request Information</div>
            {orderItems?.map((currentItem, key) => (
              <div key={key}>
                <Accordion
                  className='mb-2'
                  expanded={currentItem.isExpand}
                  onChange={handleChange(`panel${key}`)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    id='panel1a-header'
                    className='accordion-summary'
                  >
                    <Typography
                      sx={{
                        width: '100%',
                        flexShrink: 0,
                        color: '#707070',
                        fontSize: '16px',
                      }}
                    >
                      {currentItem?.name}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className='accordion-details'>
                    <div className='row mt-2'>
                      <div className='col-md-2'>Scheduled for:</div>
                      <div className='col-md-9 details-text'>{currentItem.scheduledFor}</div>
                    </div>
                    <div className='row mt-2'>
                      <div className='col-md-2'>Instructions:</div>
                      <div className='col-md-9 details-text'>{currentItem.instructions}</div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6'>
            {(order?.status === HOUSEKEEPING_STATUS_NEW_REQUEST ||
              order?.status === HOUSEKEEPING_STATUS_ON_HOLD) && (
              <Button
                variant='contained'
                className='accept-btn'
                color='primary'
                disabled={order?.status === HOUSEKEEPING_STATUS_ON_HOLD}
                type='button'
                onClick={() => {
                  onUpdatingStatus(
                    'ASSIGNED',
                    'Request accepted successfully',
                    'Error occurred while resolving request',
                  );
                }}
              >
                Accept Request
              </Button>
            )}

            {order?.status === HOUSEKEEPING_STATUS_ASSIGN_REQUEST && (
              <Button
                className='accepted-button-static'
                variant='outlined'
                color='primary'
                type='button'
              >
                Accepted
              </Button>
            )}
          </div>
          <div className='col-md-6 d-flex justify-content-center'>
            {order?.status === HOUSEKEEPING_STATUS_ON_HOLD && (
              <Button
                variant='outlined'
                color='secondary'
                type='button'
                onClick={() => {
                  onUpdatingStatus(
                    'NEW_REQUEST',
                    'Request opened successfully',
                    'Error occurred while opening request',
                  );
                }}
              >
                Open Request
              </Button>
            )}

            {order?.status === HOUSEKEEPING_STATUS_NEW_REQUEST && (
              <Button
                variant='outlined'
                color='secondary'
                type='button'
                onClick={() => {
                  onUpdatingStatus(
                    'ON_HOLD',
                    'Request put on hold successfully',
                    'Error occurred while holding request',
                  );
                }}
              >
                Hold Request
              </Button>
            )}

            {order?.status === HOUSEKEEPING_STATUS_ASSIGN_REQUEST && (
              <Button
                variant='contained'
                color='primary'
                type='button'
                onClick={() => {
                  onUpdatingStatus(
                    'RESOLVED',
                    'Request resolved successfully',
                    'Error occurred while resolving request',
                  );
                }}
              >
                Resolve Request
              </Button>
            )}
          </div>
          {order?.status === HOUSEKEEPING_STATUS_ON_HOLD && (
            <div className='mt-2 open-request-text'>Open request to accept this ticket.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardHousekeepingView;
